<!-- eslint-disable prettier/prettier -->
<template>
  <div class="quoteright">
    <div id="viewcart" :class="{ show: showMobileCart }">
      <div class="quickcart">
        <span class="close" @click="hideMobileCart()">X</span>
        <div class="sticky-quickcart">
          <div class="subtitle">Your Quote</div>
          <br />
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="line-item"
          >
            <tbody>
              <tr>
                <td>Policy Length</td>
                <td>{{ quote.info.policyLength }} Year</td>
              </tr>
            </tbody>
          </table>
          <br /><strong>Renters Insurance</strong>
          <table
            width="100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="line-item"
          >
            <tbody>
              <tr>
                <td>Coverage Start</td>
                <td>{{ formatDate(quote.info.coverageStartDate) }}</td>
              </tr>
              <tr>
                <td>Your liability</td>
                <td>
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td>Personal Property Coverage</td>
                <td>
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails
                        .personalPropertyAmount
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td>Deductible</td>
                <td>
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails.deductible
                    )
                  }}
                </td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.hurricaneDeductible !== null">
                <td>Huricane deductible</td>
                <td>
                  {{
                    formatAmountWithoutCents(
                      quote.rentersInsurance.quoteCoverageDetails
                        .hurricaneDeductible
                    )
                  }}
                </td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.replacementCost">
                <td>Replacement Cost</td>
                <td>Included</td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.waterBackup">
                <td>Water Sewer Backup</td>
                <td>Added</td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.identityFraud">
                <td>Fraud Expense Protection</td>
                <td>Added</td>
              </tr>
              <tr v-if="quote.rentersInsurance.quoteCoverageDetails.earthquake">
                <td>Earthquake</td>
                <td>Added</td>
              </tr>
            </tbody>
          </table>
          <!---------------------------------------------------------------------->
          <div v-if="quote.hasPersonalInsurance && quote.showAddonOnCart">
            <br /><strong>Accidental Damage Personal Property Coverage (Add-On)</strong>
            <table
              width="100%"
              border="0"
              cellspacing="0"
              cellpadding="0"
              class="line-item"
            >
              <tbody>
                <tr>
                  <td>Coverage Start</td>
                  <td>
                    {{ quote.hasPersonalInsurance ? currentDate : "N/A" }}
                  </td>
                </tr>
                <tr v-if="quote.hasPersonalInsurance">
                  <td>Include</td>
                  <td>✓</td>
                </tr>
                <tr>
                  <td>Coverage</td>
                  <td>
                    {{
                      quote.hasPersonalInsurance
                        ? formatAmountWithoutCents(
                            quote.personalInsurance.coverageAmount
                          )
                        : "N/A"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Deductible</td>
                  <td>
                    {{
                      quote.hasPersonalInsurance
                        ? quote.personalInsurance.deductibleAmountText
                        : "N/A"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!------------------------------------------------------------------->
          <div class="total">
            Due Today: <b>{{ formatAmount(quoteTotal) }}</b>
          </div>
        </div>
      </div>
      <div class="paymentplan">
        <div style="text-align: center"><strong>Payment Breakdown</strong></div>
        <br />
        <b>Renters Insurance</b>
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tbody>
            <tr v-if="quote.rentersInsurance.dueToday">
              <td>Payment Due Today:</td>
              <td align="right" valign="top">
                {{ formatAmount(quote.rentersInsurance.dueToday) }}
              </td>
            </tr>
            <tr v-if="quote.rentersInsurance.paymentOption == 1">
              <td>
                {{ quote.rentersInsurance.numberOfPayments - 1 }} monthly
                installments<br />
                <em>Includes
                  {{ formatAmount(quote.rentersInsurance.installmentAmount) }} +
                  {{ formatAmount(quote.rentersInsurance.serviceFee) }} billing fee
                </em>
              </td>
              <td align="right" valign="top">
                {{
                  formatAmount(
                    quote.rentersInsurance.installmentAmount +
                      quote.rentersInsurance.serviceFee
                  )
                }}
              </td>
            </tr>
            <tr v-if="quote.rentersInsurance.paymentOption == 3">
              <td>
                {{ quote.rentersInsurance.numberOfPayments - 1 }} installments
                (60 days apart)<br />
                <em>Includes
                  {{ formatAmount(quote.rentersInsurance.installmentAmount) }} +
                  {{ formatAmount(quote.rentersInsurance.serviceFee) }} billing fee
                </em>
              </td>
              <td align="right" valign="top">
                {{
                  formatAmount(
                    quote.rentersInsurance.installmentAmount +
                      quote.rentersInsurance.serviceFee
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <template v-if="quote.hasPersonalInsurance && quote.showAddonOnCart">
          <hr />
          <br />
          <b>Accidental Damage Add-on</b>
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr v-if="quote.personalInsurance.paymentOption == 2">
                <td>
                  Payment Due Today:<br />
                  <em v-if="processingFee != 0">Includes
                    {{ formatAmount(quote.personalInsurance.annualAmount) }}
                    <span>+ {{ formatAmount(processingFee) }} processing fee</span> 
                  </em>
                </td>
                <td align="right" valign="top">
                  {{
                    formatAmount(
                      quote.personalInsurance.annualAmount + processingFee
                    )
                  }}
                </td>
              </tr>
              <tr v-if="quote.personalInsurance.paymentOption == 1">
                <td>
                  Payment Due Today:<br />
                  <em v-if="processingFee != 0">Includes
                    {{ formatAmount(quote.personalInsurance.monthlyAmount) }} 
                    <span>+ {{ formatAmount(processingFee) }} processing fee</span>    
                  </em>
                </td>
                <td align="right" valign="top">
                  {{
                    formatAmount(
                      quote.personalInsurance.monthlyAmount + processingFee
                    )
                  }}
                </td>
              </tr>
              <tr v-if="quote.personalInsurance.paymentOption == 1">
                <td>11 monthly installments</td>
                <td align="right" valign="top">
                  {{
                    formatAmount(
                      quote.personalInsurance.monthlyAmount + processingFee
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { LocalDate, DateTimeFormatter } from "@js-joda/core";
import { Quote } from "@/models/Quote";
import { PaymentOptions } from "@/models/QuoteInsurance";
import {
  calculateQuoteTotal,
  formatAmountWithoutCents,
  formatAmount,
} from "@/utils/Utils";
import { Defaults } from "@/models/Defaults";
import { addNoScroll, removeNoScroll } from "@/utils/NoScroll";
import { inject, onMounted, onBeforeUnmount } from "vue";
import { ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";

const shouldShowMobileCart: Ref<boolean> = ref(false);
const inj = inject("$emitter");
const quote = useQuoteStore();

onMounted(() => {
  window.addEventListener("popstate", onPopState);
  (inj as any).on("show-mobile-cart", () => {
    showMobileCart.value = true;
  });
});
onBeforeUnmount(() => {
  // remove the event listener
  window.removeEventListener("popstate", onPopState);
  (inj as any).off("show-mobile-cart", () => {
    showMobileCart.value = false;
  });
});

const showMobileCart = computed({
  get: () => shouldShowMobileCart.value,
  set: (value: boolean) => {
    shouldShowMobileCart.value = value;
    if (value) {
      addNoScroll();
    } else {
      removeNoScroll();
    }
  },
});

function hideMobileCart() {
  showMobileCart.value = false;
}

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});

//Function not used
// function onQuoteChanged(): void {
//   const num = quoteTotal.valueOf();
// }

function formatDate(value: string) {
  if (value) {
    return LocalDate.parse(value).format(
      DateTimeFormatter.ofPattern("M/d/yyyy")
    );
  }
}

const currentDate: ComputedRef<string> = computed(() => {
  return LocalDate.now()
    .plusDays(1)
    .format(DateTimeFormatter.ofPattern("M/d/yyyy"));
});

// function formatAmountWithoutCents(value: number): string {
//   return formatAmountWithoutCents(value);
// }
//TODO export formatAmount in utils helper, pure function
// function formatAmount(value: number): string {
//   const num = Number(value);
//   // Create our number formatter.
//   const formatter = new Intl.NumberFormat("en-US", {
//     style: "currency",
//     currency: "USD",

//     // These options are needed to round to whole numbers if that's what you want.
//     //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//     //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
//   });

//   return num ? formatter.format(num) : "N/A";
// }

//function not used
// function formatPaymentOption(value: any) {
//   const num = Number(value) as PaymentOptions;
//   switch (num) {
//     case PaymentOptions.Monthly:
//       return "Monthly";
//     case PaymentOptions.Annual:
//       return "Annual";
//     case PaymentOptions.FourPay:
//       return "4 Pay";
//     default:
//       return "Unknown";
//   }
// }

const processingFee: ComputedRef<number> = computed(() => {
  if (quote.personalInsurance.paymentOption == PaymentOptions.None) {
    return 0;
  }
  return quote.personalInsurance.paymentOption == PaymentOptions.Monthly
    ? quote.monthlyProcessingFee
    : quote.processingFee;
});

/**
 * Back or forward button has been clicked on browser.
 */
function onPopState() {
  // Remove no scroll, so when we return to the main window it can scroll
  removeNoScroll();
}
</script>
